<template>
  <main role="main">
    <div class="page-con">
        <ul class="about-con">
			<li class="about-con1">
				<div class="about-con1-txt">
					<h3 style="padding-top:26px;">{{ $t('MISSION.TITLE') }}</h3>
					<div class="con-txt" :class="{'con-txt-en':lang=='en'}">
						<p v-html="$t('MISSION.CONTENT')" :class="{'con-txt-p-en':lang=='en'}"></p>
					</div>
					<img src="../../../static/images/2/2-1-1-img-m.jpg" alt="">
				</div>
			
			</li>
			<li class="about-con-l con1">
				<div class="about-con-txtbox">
				<div class="about-iconbox blue" :class="{'about-iconbox-en':lang=='en'}">
					<i></i>
					<h4>{{ $t('MISSION.CRTITLE') }}</h4>
					<p v-if="lang=='zh'">Corporate Reorganization/ Corporate Restructuring</p>
				</div>
				<div class="about-txtbox blue" :class="{'about-txtbox-en':lang=='en'}">
					<p v-html="$t('MISSION.CRCONTENT1')"></p>
					<p v-html="$t('MISSION.CRCONTENT2')"></p>	
					<p v-html="$t('MISSION.CRCONTENT3')"></p>
				</div>
				</div>
			</li>
        <li class="about-con-l con2">
            <div class="about-con-txtbox">
            
            <div class="about-txtbox green" :class="{'about-txtbox-en':lang=='en'}">
                <p v-html="$t('MISSION.CBCONTENT1')"></p>
                <p v-html="$t('MISSION.CBCONTENT2')"></p>
                <p v-html="$t('MISSION.CBCONTENT3')"></p>
            </div>
            <div class="about-iconbox green" :class="{'about-iconbox-en':lang=='en'}">
                <i></i>
                <h4>{{ $t('MISSION.CBTITLE') }}</h4>
                <p v-if="lang=='zh'">Consumer Bankruptcy</p>
            </div>
            </div>
        </li>
        <li class="about-con-l con3">
            <div class="about-con-txtbox">
            <div class="about-iconbox orange" :class="{'about-iconbox-en':lang=='en'}">
                <i></i>
                <h4>{{ $t('MISSION.FBTITLE') }}</h4>
                <p v-if="lang=='zh'">Future Prospects</p>
            </div>
            <div class="about-txtbox orange" :class="{'about-txtbox-en':lang=='en'}">
                <p v-html="$t('MISSION.FBCONTENT1')"></p>
                
                <p v-html="$t('MISSION.FBCONTENT2')"></p>
            </div>
            </div>
        </li>
        </ul>
    </div>
    <IndexFooter></IndexFooter>
</main>
</template>
<script>

export default {
    name: 'About',
    data () {
        return {
            lang:''
        }
    },
    mounted () {
        this.lang = localStorage.getItem('language') || 'zh';
    },
    created(){
    },
    methods: {
    }
}
</script>
<style scoped>
.p-en{
    padding-top: 60px !important;
    margin-bottom: 12px !important;
}
.con-txt-en{
    padding-top: 25px !important;
    padding-bottom: 50px !important;
}
.con-txt-p-en{
    font-size: 16px !important;
    line-height: 200% !important;
}
.about-txtbox-en p{
    font-size:16px !important;
}
.about-iconbox-en h4{
    width: 268px !important;
    padding: 0 10px !important;
    font-size:28px !important;
    font-weight: 700 !important;
    text-align: center !important;
    margin:20px 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index/About.vue